import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { companyService } from '../../services/napoleon';

import {
  resetRegister,
  updateCompanyId,
  updateRegisterStep,
  updateUserId,
} from '../../redux/actions/userActions';
import {
  FIND_IS_AUTHENTICATED,
  FIND_TOKEN,
  FIND_TOKEN_DECODE,
  RESET_USER_STATE,
} from '../../redux/types';
import { REGISTER_STEPS, STEP_ORDER } from '../../constants/registerSteps';

export default function useAuth(onEvent) {
  const changeForm = () => {
    onEvent();
  };

  const history = useHistory();
  const dispatch = useDispatch();

  const login = async (token) => {
    const decoded = jwtDecode(token);
    const {
      user: { companyId, id },
    } = decoded;

    if (id) {
      dispatch(updateUserId(id));
    }

    if (companyId) {
      dispatch(updateCompanyId(companyId));
      const response = await companyService.getCompanyById(companyId);

      const collaboratorSizeRangeId = response.data;

      if (collaboratorSizeRangeId) {
        dispatch({ type: FIND_TOKEN, token });
        dispatch({ type: FIND_TOKEN_DECODE, decodeToken: decoded });
        dispatch({ type: FIND_IS_AUTHENTICATED, isAuthenticated: true });
      } else {
        dispatch(updateRegisterStep(STEP_ORDER.indexOf(REGISTER_STEPS.COLLABORATORS)));
        changeForm();
      }
    } else {
      dispatch(updateRegisterStep(STEP_ORDER.indexOf(REGISTER_STEPS.COMPANY_INFO)));
      changeForm();
    }
  };

  const logout = () => {
    dispatch({ type: RESET_USER_STATE });
    dispatch(resetRegister());
    history.push('/login');
  };

  return { login, logout };
}
